import { html } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-lang')
export class RgLang extends RaygunElement {

  @property({ type: String })
  title = 'EN'

  @property({ type: Boolean, reflect: true })
  open = false

  @query('details')
  details

  registerEvents() {
    return {
      'document.click': this.onDocumentClick,
      'document.keydown:esc': this.close,
    }
  }

  onListToggle = async (event) => {
    await this.updateComplete
    this.open = event.target.open
  }

  close = (event) => {
    this.details.open = false
  }

  onDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      event.stopPropagation()
      this.close()
    }
  }

  render() {
    return html`
      <nav class="language-selector">
        <details
          ?open="${this.open}"
          @toggle=${this.onListToggle}
        >
          <summary>
            ${ this.title }
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 6"><path fill="#F26E50" d="M4 6 .536 0h6.928L4 6Z"/></svg>
          </summary>
          <ul class="language-list">
            ${ this.slot().map(child => {
              return html`
              <li>
                ${ child }
              </li>`
            }) }
          </ul>
        </details>
      </nav>
    `;
  }
}
